import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { onlyNumberRegexp } from 'lib/regexp/regexpConst';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { conversiondayReport } from 'lib/api/conversion';
import { showSuccessSnackbar } from 'modules/snackbar';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const Statistics = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [initialization, setInitialization] = useState(false);
  const initParams = {
    sort: 'desc',
    order: 'REG_DTTM',
    pltfomTpCode: 'all',
    trackerFlag: 'all',
    itlTpCode: '01,03,04,05,08,09,10,12,13,98,99',
    sDate: moment().add(-29, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };
  const [params, setParams] = useState(initParams);

  const initInput = {
    price: '',
  };
  const [input, setInput] = useState(initInput);
  const initInputError = {
    price: false,
  };
  const [inputError, setInputError] = useState(initInputError);

  const t1 = moment(params['sDate']);
  const t2 = moment(params['eDate']);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  useEffect(() => {
    if (params.page === 0) {
      let newParams = { ...params };
      delete newParams['page'];
      setParams(newParams);
    } // eslint-disable-next-line
  }, [params]);

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleInput = (newData) => {
    if (JSON.stringify(input) !== JSON.stringify(newData)) {
      setInput(newData);
    }
  };

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
      setInput(initInput);
      setInputError(initInputError);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    PNM: {
      makeBody: (rowObj, headsMap) => {
        const pnm = getHeadObj(headsMap, 'PNM');
        return makeRowColumn(rowObj['PNM'], pnm.type, pnm.format);
      },
      bodyStyle: { maxWidth: 450 },
    },
  };

  const handleSubmit = () => {
    let newParams = { ...params, ...input };
    if (!onlyNumberRegexp.test(newParams.price)) {
      setInputError({
        price: true,
      });
      handleClickSnackbar({
        message: t('금액 필터는 숫자만 입력 가능합니다.'),
        option: {
          type: 'error',
        },
      });
    } else {
      setInputError({
        price: false,
      });
      if (newParams.price === '') {
        delete newParams['price'];
      }
      setParams(newParams);
    }
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDisplayFilter={false}
          useTracker
        />
        <NewInput
          type="filter"
          name="price"
          params={input}
          label="주문금액"
          placeholder="숫자만 입력 가능합니다."
          value={input.price}
          error={inputError.price}
          callBack={handleInput}
        />
        <NewButton type="filterButton" onClick={handleSubmit} disableRipple>
          {t('검색')}
        </NewButton>
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={conversiondayReport}
        customized={customized}
        useSearch={false}
        useTotal={false}
        useExcel={moment.duration(t2.diff(t1)).asDays() < 2}
        toolTip={t('엑셀다운로드는 최대 2일까지만 지원합니다.')}
      />
    </>
  );
};

export default Statistics;
